export const API_URL = {
    // Auth
    SIGN_UP: 'signup',
    VERIFY_SIGNUP_OTP: 'verifyOtp',
    LOG_IN: 'user/sendOtp',
    VERIFY_LOGIN_OTP: 'user/verifyOtp',
    LOGOUT: 'user/logout',
    SIGNUP_PROFILE_UPDATE: 'userProfile/signupProfileUpdate',
    UPLOAD_KYC_DOCUMENT: 'userProfile/uploadKyc',
    
    // General
    GET_PROFILE_CATEGORY_LIST: 'profileCategory/getList',
    GET_LOCATION_LIST: 'location/getList',
    GET_PROJECT_CATEGORY_LIST: 'projectCategory/getList',
    GET_ROLE_TYPE_LIST: 'roleType/getList',
    GET_REPORT_TYPE_LIST: 'report/getList',
    REPORT_PROFILE: 'report/profile',
    REPORT_JOB: 'report/job',

    // Audition Panel
    GET_JOB_LIST: 'job/getList',
    MARK_JOB_SHORTLIST: 'job/markShortlist',
    REMOVE_JOB_SHORTLIST: 'job/removeShortlisted',
    APPLY_FOR_JOB: 'job/apply',
    WITHDRAW_JOB_APPLICATION: 'job/withdrawApplication',
    GET_JOB_BY_ID: 'job/get',
    GET_JOB_FILTER: 'filter/get',
    UPDATE_JOB_FILTER: 'filter/update',
    
    // User Panel
    GET_ARTIST_LIST: 'profile/getArtistsList',
    GET_FAVOURITE_DIRECTOR: 'profile/getFavoriteDirectorsList',
    GET_PROFILE_BY_ID: 'profile/get',
    MARK_PROFILE_FAVORITE: 'profile/markFavourite',
    
    // Media
    GET_MEDIA_LIST: 'media/getMediaList',
    PIN_MEDIA: 'media/pin',
    DELETE_MEDIA: 'media/delete',
    UPLOAD_MEDIA: 'media/upload',
    UPLOAD_VIDEO: 'media/uploadVideo',
    UPLOAD_SELFIE: 'media/uploadSelfie',
    GET_MEDIA_TAGS: 'tag/getList',
    ADD_MEDIA_TAGS: 'tag/add',

    // Notification
    GET_NOTIFICATIONS: 'notification/getNotification',
    UPDATE_REQUEST: 'request/update',

    // Profile
    GET_PROFILE_DATA: 'userProfile/get',
    UPLOAD_PROFILE_PIC: 'userProfile/upload/profilePic',
    UPDATE_PROFILE: 'userProfile/update',
    ADD_EDUCATION_DATA: 'userProfile/addEducation',
    UPDATE_EDUCATION_DATA: 'userProfile/updateEducation',
    DELETE_EDUCATION_DATA: 'userProfile/deleteEducation',
    GET_WORKDONE_LIST: 'workdone/getList',
    ADD_WORKDONE_DATA: 'workdone/add',
    UPDATE_WORKDONE_DATA: 'workdone/update',
    DELETE_WORKDONE_DATA: 'workdone/delete',
    
}

export const StatusCodes = {
    SUCCESS: 200,
    SUCCESS_WAIT: 210,
    NO_DATA_FOUND: 412,
    VALUE_NOT_ALLOWED: 413,
    AUTH_FAILED: 401,
    BAD_REQUEST: 400,
    INVALID_ACCESS: 403,
    INCORRECT_URL: 404,
    METHOD_NOT_SUPPORTED: 405,
    NOT_ACCEPTABLE: 406,
    REQUEST_TIMEOUT: 408,
    REQUEST_CANCELLED: 499,
    SERVER_ERROR: 500,
    DUPLICATE_DATA: 420,
    UNSUPPORTED_MEDIA_TYPE: 415
}

export const AxiosError = {
    code: StatusCodes.REQUEST_TIMEOUT,
    message: 'Request Timeout!!',
    description: 'Request Timeout of 15 seconds!',
}